<template>
  <div class="whs-detail">
    <Status
      v-if="isLoading(wait.hotel) || error"
      :wait="wait.hotel"
      :error="error"
      :errorMessage="errorMessage"
    />
    <div v-if="hotel" class="whs-detail-result">
      <Slider v-if="hotel.info && hotel.info.images.length > 0" :images="hotel.info.images" />

      <div class="whs-detail-hotel-header" v-if="hotel.info">
        <div class="whs-detail-hotel-header-main">
          <div class="whs-detail-hotel-name">
            {{ hotel.info.name }}
            <HotelStars :stars="hotel.info.star_rating" :size="14" style="margin-left: 8px;" />
          </div>
          <div class="whs-small">{{ hotel.info.address }}</div>
        </div>
        <div class="whs-detail-hotel-header-next" v-if="rooms.length > 0">
          <div class="whs-detail-room-price">{{ toLocalePrice(minRoomPrice) }}</div>
          <div class="whs-small">{{ nightsAdults }}</div>
          <div class="whs-button-main" @click="goTo('rooms')">Посмотреть цены</div>
        </div>
        <Status
          v-else-if="isLoading(wait.rooms) || error"
          :wait="wait.rooms"
          :error="error"
          :errorMessage="errorMessage"
        />
      </div>

      <div class="whs-detail-hotel-main" v-if="hotel.info">
        <div class="whs-detail-hotel-params">
          <div
            class="whs-list-rating-wrap"
            v-if="hotel.info.rating && hotel.info.rating.total"
            :class="classNameFromRating(hotel.info.rating.total)"
          >
            <div class="whs-list-rating__total">{{ hotel.info.rating.total }}</div>
            <div class="whs-list-rating__verbose">{{ hotel.info.rating.total_verbose }}</div>
            <span class="review-total">Отзывов: {{reviews.length}}</span>
          </div>

          <div
            class="whs-button-third"
            @click="goTo('reviews')"
            style="margin-bottom: 24px"
          >Посмотреть отзывы</div>

          <Icons v-if="hotel.info.serp_filters" :info="hotel.info" />

          <div class="whs-button-third" @click="goTo('amenities')">Все услуги и удобства</div>
        </div>
        <div class="whs-detail-hotel-description" v-if="hotel.info.description_short">
          <div class="whs-detail-hotel-description-title">Описание отеля</div>
          <div
            class="whs-detail-hotel-description-paragraphs"
            v-html="hotel.info.description_short"
          ></div>
          <div class="whs-button-third" @click="goTo('description')">Полное описание</div>
        </div>
      </div>

      <Map
        ref="map"
        v-if="hotel.main_info && hotel.main_info.latitude"
        :longitude="parseFloat(hotel.main_info.longitude)"
        :latitude="parseFloat(hotel.main_info.latitude)"
      />

      <RoomGroups v-if="roomGroups.length > 0" :roomGroups="roomGroups" ref="rooms" />
      <Status
        v-else-if="isLoading(wait.rooms)"
        :wait="wait.rooms"
        :error="error"
        :errorMessage="errorMessage"
      />
      <div v-else class="whs-detail-sold">
        <div class="whs-detail-sold-title">Все номера распроданы</div>
        К сожалению, в этом отеле нет доступных вариантов размещения на выбранный период {{ checkInOut }}
        <div class="whs-detail-sold-buttons">
          <div
            class="whs-button-main"
            @click="$store.commit('hero/minify', false)"
          >Выбрать другой отель</div>
          <div
            class="whs-button-third"
            @click="$store.commit('hero/minify', false)"
          >Указать другие даты</div>
        </div>
      </div>

      <Reviews
        v-if="hotel.info && hotel.info.rating && reviews.length > 0"
        :reviews="reviews"
        :rating="hotel.info.rating"
        ref="reviews"
        :openReviews="openReviews"
        :reviewsAreOpen="reviewsAreOpen"
      />

      <div class="whs-detail-hotel-fulldescription" ref="description" v-if="hotel.info">
        <div class="whs-detail-hotel-fulldescription-title">Описание отеля</div>
        <div class="whs-detail-hotel-fulldescription-paragraphs" v-html="hotel.info.description"></div>
      </div>

      <Amenitites
        v-if="hotel.info && hotel.info.amenities && hotel.info.amenities.length > 0"
        ref="amenities"
        :amenities="hotel.info.amenities"
      />

      <div class="whs-detail-hotel-politics" ref="politics"></div>
    </div>
  </div>
</template>

<script>
import Map from '@/components/DetailMap.vue';
import { mapState, mapGetters } from 'vuex';
import { calcPrice } from '@/api';
import Slider from '../components/HotelDetailSlider.vue';
// import Rooms from '../components/HotelDetailRooms.vue';
import RoomGroups from '../components/HotelDetailRoomGroups.vue';
import Reviews from '../components/HotelDetailReviews.vue';
import Amenitites from '../components/HotelDetailAmenities.vue';
import Icons from '../components/HotelListIcons.vue';
import HotelStars from '../components/HotelStars.vue';
import Status from '../components/Status.vue';

// import Vue from 'vue';

export default {
  name: 'HotelDetail',
  components: {
    Slider,
    // Rooms,
    Status,
    HotelStars,
    Reviews,
    Icons,
    Amenitites,
    RoomGroups,
    Map
  },
  data: function() {
    return {
      currencyText: 'руб.',
      reviewsAreOpen: false,
      roomIsOpen: false
    };
  },
  computed: {
    ...mapState(['loading']),
    ...mapState('hotel', [
      'hotel',
      'error',
      'errorMessage',
      'rooms',
      'room',
      'reviews',
      'hotelWaitingRooms',
      'room',
      'wait',
      'roomGroups'
    ]),
    ...mapState('hero', ['nightsAdults', 'adults', 'children']),
    ...mapGetters(['isLoading']),
    ...mapGetters('hero', [
      'checkin',
      'checkout',
      'checkInOut',
      'toLocalePrice'
    ]),
    loading: {
      get() {
        return (
          (this.$store.state.hotels && this.$store.state.hotels.loading) ||
          this.$store.state.hotel.loading
        );
      }
    },
    // roomGroups: {
    //   get() {
    //     return Array.from(new Set(this.rooms.map(el => el.room_group_id)));
    //   }
    // },
    minRoomPrice: {
      get() {
        if (this.rooms.length === 0) return;
        return Math.min(...this.rooms.map(room => calcPrice(room)));
      }
    }
  },
  watch: {
    hotel: function(hotel) {
      if (!hotel || this.hotelWaitingRooms) return;

      const query = {
        hotel_id: hotel.id,
        checkin: this.checkin,
        checkout: this.checkout,
        adults: this.adults
      };

      if (this.children.length > 0) query.children = this.children;

      this.$store.commit('hotel/setHotelWaitingRooms');
      this.$store.commit('hotel/clearAvailableRooms');
      this.$store.dispatch('hotel/getAvailableRooms', query);
      this.$store.commit('hotel/clearHotelReviews');
      this.$store.dispatch('hotel/getHotelReviews', {
        ids: hotel.id
      });
    },
    rooms: function(rooms) {
      if (rooms.length === 0) return;

      // this.$store.commit('hotel/updateRoomsInfo');
      this.$store.commit('hotel/updateRoomGroups');
    }
  },
  methods: {
    // toLocalePrice(price) {
    //   return `${Math.ceil(price, 10).toLocaleString('ru-Ru')} ${
    //     this.currencyText
    //   }`;
    // },
    goTo(ref) {
      if (!this.$refs[ref]) return;
      this.$refs[ref].scrollIntoView
        ? this.$refs[ref].scrollIntoView()
        : this.$refs[ref].$el.scrollIntoView();
    },
    classNameFromRating(rating) {
      const rate = parseInt(rating, 10);
      if (rate >= 9) return 'best';
      else if (rate >= 8) return 'better';
      else if (rate >= 7) return 'good';
    },
    openReviews() {
      this.reviewsAreOpen = !this.reviewsAreOpen;
    }
  }
};
</script>

<style>
.whs-detail-hotel-fulldescription-paragraphs h4 {
  font-size: 18px;
  font-weight: 500;
  margin: 0;
}
.whs-detail-hotel-fulldescription-paragraphs h4:before {
  content: '\f594';
  width: 24px;
  font: 900 normal normal 18px/1 'Font Awesome 5 Pro';
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  color: var(--color-alt-5);
  margin-right: 12px;
}
</style>

<style scoped>
.whs-detail-sold {
  background-color: var(--color-bg-dark);
  margin-top: 18px;
  margin-bottom: 18px;
  padding: 8px 18px;
  border: 1px solid var(--color-main);
}
.whs-detail-sold-title {
  font-size: 22px;
  padding-bottom: 8px;
}
.whs-detail-sold-buttons {
  display: flex;
  margin: 18px -8px 0;
}
.whs-detail-sold-buttons div {
  margin: 0 8px;
}
.whs-detail-hotel-reviews-title {
  font-size: 24px;
  padding: 8px 18px;
}
.review-total {
  background-color: var(--color-bg);
  padding: 0 8px;
  font-size: 14px;
  border-radius: 24px;
  margin: 0 8px;
  white-space: nowrap;
}
.whs-detail {
  width: 100%;
  /* max-width: 800px; */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: var(--color-bg);
}
.whs-detail-result {
  width: 100%;
}
.whs-detail-hotel-header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: 12px 8px;
  width: 100%;
  background-color: #fff;
  border-bottom: 1px solid var(--color-alt-5);
}
.whs-detail-hotel-header-main {
  padding: 8px 12px;
}

.whs-detail-room-price {
  padding-top: 4px;
  font-size: 22px;
  font-weight: 700;
}

.whs-detail-hotel-header-next {
  padding: 8px 12px;
}
.whs-detail-hotel-main {
  display: flex;
  flex-wrap: wrap;
  background-color: #fff;
  padding: 8px 0;
}
.whs-detail-hotel-params {
  flex: 1;
  padding: 8px 18px;
}
.whs-detail-hotel-params > .whs-button-second {
  margin-bottom: 20px;
}
.whs-detail-hotel-description {
  padding: 8px 18px;
  flex: 2;
}
.whs-detail-hotel-description-title {
  font-size: 18px;
  margin-bottom: 4px;
}
.whs-detail-hotel-description-paragraphs {
  margin-bottom: 4px;
}
.whs-detail-hotel-name {
  display: flex;
  align-items: center;
  font-size: 24px;
  font-weight: 500;
}
.whs-list-rating-wrap {
  display: flex;
  align-items: center;
}
.whs-list-rating-wrap .whs-button-second {
}
.whs-list-rating__total {
  width: 28px;
  padding: 3px;
  margin-right: 4px;
  background-color: var(--color-bg);
  font-weight: 600;
  font-size: 16px;
  border-radius: 100%;
  text-align: center;
}
.best .whs-list-rating__total {
  background-color: var(--color-third);
  color: #fff;
}
.better .whs-list-rating__total {
  background-color: var(--color-bg-warm);
  color: #fff;
}
.good .whs-list-rating__total {
  background-color: var(--color-alt);
  color: #fff;
}
.whs-list-rating__verbose {
  font-size: 16px;
}

.whs-detail-hotel-fulldescription {
  margin: 24px 0;
  padding: 18px;
  background-color: #fff;
  border-radius: 4px;
  -webkit-box-shadow: 0 0 1px var(--color-text-5), 0 0 8px var(--color-bg-dark);
  box-shadow: 0 0 1px var(--color-text-5), 0 0 8px var(--color-bg-dark);
}
.whs-detail-hotel-fulldescription-title {
  font-size: 24px;
  margin-bottom: 18px;
}
</style>